<template>
  <!-- <ul class="doc-menu">
    <li
      v-for="(item, index) in dataList"
      :class="{ activeItem: item.id === '1' }"
      :key="index"
      class="doc-menu__item"
    >
      {{ item.name }}
    </li>
  </ul> -->
  <div class="doc-menu">
    <Menu
      ref="menu"
      theme="light"
      mode="vertical"
      :active-name="activeKey"
      :open-names="openName"
      :accordion="true"
      v-if="dataList.length"
    >
      <div v-for="item in dataList" :key="item.apiCode">
        <Submenu
          v-if="item.children && item.children.length"
          :name="item.name"
          :key="item.catalogCode"
        >
          <template slot="title">
            <div class="menu-title">{{ item.catalogText }}</div>
          </template>

          <Menu-item
            v-for="cell in item.children"
            :key="cell.apiCode"
            :name="cell.name"
            :to="{ name: 'docApiInfo', params: { id: cell.apiCode } }"
          >
            <!-- <div class="menu-title">{{ cell.apiCode }}</div> -->
            <!-- <p class="remark">{{ cell.apiName }}</p> -->
            {{ cell.apiName }}
          </Menu-item>
        </Submenu>
        <MenuItem
          v-else
          :key="item.catalogCode"
          :name="item.catalogCode"
          :to="{ name: 'docApiInfo', params: { id: item.apiCode } }"
        >
          <div class="menu-title">{{ item.catalogText }}</div>
        </MenuItem>
      </div>
    </Menu>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      activeKey: this.$route.params.id,
      openName: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.init();
  },
  watch: {
    $route() {
      this.activeKey = this.$route.params.id;
      this.init();
    },
    dataList() {
      this.init();
    }
  },
  methods: {
    init() {
      this.dataList.forEach(item => {
        if (item.apiCode !== this.$route.params.id) {
          if (item.children && item.children.length) {
            item.children.forEach(cell => {
              if (cell.apiCode === this.$route.params.id) {
                this.openName = [item.catalogCode];
              }
            });
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.menu && this.$refs.menu.updateOpened();
      });
    }
  },
  components: {}
};
</script>

<style lang="less">
.doc-menu {
  width: 240px;
  .ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: #f0f6ff;
    color: @color-primary;
    &::after {
      background: @color-primary;
    }
  }
  .ivu-menu-vertical .ivu-menu-item:hover,
  .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: @color-primary;
  }
  .ivu-menu-submenu .ivu-menu-item {
    padding: 2px 24px;
    margin-bottom: 15px;
  }

  .ivu-menu-item {
    min-height: 40px;
  }
  .menu-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .remark {
    font-size: 12px;
    color: @color-font-info;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ivu-menu-vertical .ivu-menu-submenu-title {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
}
</style>
